import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { formatDate, isValidDate, parseDate } from 'data/lib/dates'
import { localizeNum, tryParseFloat, isValidNumber } from "data/lib/numbers"

type DateString = string
type DateTextInputProps = {
  attrs?: Function
  id?: string
  withoutDays?: boolean
  field?: string
  onBlur?: (value: DateString) => void
  onChange?: (value: DateString) => void
  className?: string
  allowRelative?: boolean
  value: DateString,
  persist: Function,
  disabled?: boolean
  disabledText?: string
}

const format = (format, withoutDays) => s => formatDate(parseDate(s), format, withoutDays)
const invoke = (fn, ...args) => fn && fn(...args)

const DateText = (props: DateTextInputProps) => {
  const _format = format(props.withoutDays ? 'MM/YYYY' : 'MM/DD/YYYY', props.withoutDays)
  let placeholder = ""
  if(props.withoutDays) {
    if(props.allowRelative) placeholder = "MM/YYYY or Months"
    else placeholder = "MM/YYYY"
  } else {
    if(props.allowRelative) placeholder = "MM/DD/YYYY or Months"
    else placeholder = "MM/DD/YYYY"
  }

  let initialValue = ""
  if(props.value && isValidDate(props.value)) initialValue = _format(props.value)
  if(props.value && props.allowRelative && isValidNumber(props.value)) initialValue = localizeNum(props.value)

  const [value, setValue] = useState<string>(initialValue)

  useEffect(() => {
    if (!_.isNil(props.value) && value !== props.value) {
      if(isValidDate(props.value)) setValue(_format(props.value))
      if(props.allowRelative && isValidNumber(props.value)) setValue(localizeNum(props.value))
    }
    if (!props.value && value !== props.value){
      setValue('')
    }
  }, [props])

  const onBlur = _.debounce((e) => {
    if(isValidDate(value)) {
      let formatted = _format(value)
      setValue(formatted)
      props.persist(formatted);
      invoke(props.onBlur, formatted)
    } else if(props.allowRelative && isValidNumber(value)) {
      let parsed = tryParseFloat(value)
      setValue(parsed)
      props.persist(parsed);
      invoke(props.onBlur, parsed)
    } else {
      if (value === ''){
        setValue('')
        props.persist(null)
      } else if(isValidDate(props.value)) {
        let formatted = _format(props.value)
        setValue(formatted)
        props.persist(formatted);
        invoke(props.onBlur, formatted)
      } else if(props.allowRelative && isValidNumber(props.value)) {
        let parsed = tryParseFloat(props.value)
        setValue(parsed)
        props.persist(parsed);
        invoke(props.onBlur, parsed)
      }
    }
  }, 300)

  // useEffect(() => {
  //   if (isValidDate(value)) {
  //     const _format = format('YYYY-MM-DD', props.withoutDays)
  //     invoke(props.onChange, _format(value))
  //   } else if(props.allowRelative && isValidNumber(value)) {
  //     invoke(props.onChange, localizeNum(value))
  //   }
  // }, [value])

  const attrs = (props.attrs && props.field && !props.disabled && props.attrs(props.field) ) || {}

  return (
    <input
      {...props}
      id={props.id}
      className={props.className}
      onBlur={onBlur}
      onChange={e => setValue(e.target.value)}
      placeholder={props.disabled && props.disabledText ? props.disabledText : placeholder}
      type="text"
      value={value}
      disabled={props.disabled}
      {...attrs}
    />
  )
}

export default DateText
